/**
 * /vendors/new — alta de proveedor.
 *
 * La API aceptaba POST desde el principio, pero no había pantalla: el vacío de
 * /vendors decía "créalos desde Settings más adelante" y ese "más adelante"
 * nunca llegó, así que la única vía era la semilla del Excel.
 */
import { useState } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Link, useNavigate } from '@tanstack/react-router'
import { ApiError, createVendor } from '@/lib/api'
import { PageHeader } from '@/components/app-shell'
import { Card, CardBody } from '@/components/ui/card'
import { VendorForm, type VendorFormValues } from '@/components/vendor-form'

export function VendorNewPage() {
  const navigate = useNavigate()
  const qc = useQueryClient()
  const [error, setError] = useState<string | null>(null)
  const [fields, setFields] = useState<Record<string, string>>({})

  const mutation = useMutation({
    mutationFn: (values: VendorFormValues) => createVendor(values),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ['vendors'] })
      void navigate({ to: '/vendors' })
    },
    onError: (err) => {
      if (err instanceof ApiError) {
        setError(err.message)
        setFields(err.fields ?? {})
      } else setError('No se pudo crear.')
    },
  })

  return (
    <>
      <PageHeader
        title="Nuevo proveedor"
        actions={
          <Link to="/vendors" className="text-sm text-muted-foreground hover:text-foreground">
            Cancelar
          </Link>
        }
      />
      <Card className="mx-auto max-w-xl">
        <CardBody>
          <VendorForm
            submitLabel="Guardar"
            pending={mutation.isPending}
            error={error}
            fieldErrors={fields}
            onSubmit={(values) => {
              setError(null)
              setFields({})
              mutation.mutate(values)
            }}
          />
        </CardBody>
      </Card>
    </>
  )
}
